import Reveal from "./Reveal";
import { professional } from "@/config/professional";

export default function FinalCTA() {
  return (
    <section className="relative overflow-hidden bg-primary-900 py-20 md:py-32">
      {/* botanical decoration */}
      <div className="pointer-events-none absolute -right-16 -top-16 text-primary-700/30">
        <i className="ri-leaf-line text-[16rem]" aria-hidden="true"></i>
      </div>
      <div className="pointer-events-none absolute -bottom-24 -left-10 text-primary-700/20">
        <i className="ri-plant-line text-[16rem]" aria-hidden="true"></i>
      </div>

      <div className="relative mx-auto max-w-3xl px-4 text-center md:px-6">
        <Reveal>
          <h2 className="font-heading text-4xl font-semibold leading-[1.1] tracking-tight text-background-50 md:text-6xl">
            Seu cuidado pode começar hoje.
          </h2>
        </Reveal>
        <Reveal delay={80}>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-background-100/80 md:text-lg">
            Converse com Tatiana e agende uma avaliação individualizada.
          </p>
        </Reveal>
        <Reveal delay={140}>
          <a
            href={professional.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group mt-10 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-400 px-9 py-4 text-base font-semibold text-primary-950 transition-colors duration-300 hover:bg-accent-300"
          >
            {professional.cta.final}
            <i
              className="ri-whatsapp-line text-lg"
              aria-hidden="true"
            ></i>
          </a>
        </Reveal>
      </div>
    </section>
  );
}